import { ProductCarousel } from '@johnlewispartnership/wtr-content-component-library';
import type { CmsProductCarouselProps } from '@johnlewispartnership/wtr-content-component-library';
import { useFeatureFlags } from '@johnlewispartnership/wtr-website-decisioner-client/express';

import { AEM_CONTENT_RENDERER_CLIENT_ENABLE_PRODUCT_CAROUSEL } from 'constants/feature-flags';
import { useFavouritesService } from 'renderer/hooks/useFavouritesService';

/*
 * The Ingredients ProductPod will only show the favourite icon if onFavouriteClick is provided, so we need to pass a function to show the icon.
 * TODO(WPIP-82145): Add toggle favourite functionality to Product Carousel
 */
const onFavouriteClick = () => console.log('Favourite clicked');

const ProductCarouselWrapper = ({ items, ...rest }: CmsProductCarouselProps) => {
  const enableProductCarousel =
    useFeatureFlags()[AEM_CONTENT_RENDERER_CLIENT_ENABLE_PRODUCT_CAROUSEL];
  const { favourites } = useFavouritesService();

  if (!enableProductCarousel) {
    return null;
  }

  const enrichedItems =
    Object.keys(favourites).length === 0
      ? items
      : items.map(item => ({
          ...item,
          searchProduct: {
            ...item.searchProduct,
            favourite: !!favourites[item.searchProduct.lineNumber || ''],
          },
        }));

  return <ProductCarousel {...rest} items={enrichedItems} onFavouriteClick={onFavouriteClick} />;
};

export default ProductCarouselWrapper;
